import styled from 'styled-components';
import { IImageEmbedFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import { theme } from '../../../styles/theme';
import { SvgIcon } from '../../Icon';
import {
  useActionsVisibilityContext,
  withActionsVisibilityContext,
} from '../../ActionsVisibilityContext';
import CommentImageEmbed from '../CommentImageEmbed';

interface IProps {
  uploadedImagedEmbed: IImageEmbedFieldsFragment;
  onRemove: () => void;
}

const ImageWrapper = styled.div`
  position: relative;
  display: block;
  margin-top: 8px;
  width: 48px;
  height: 48px;
`;
const StyledImage = styled(CommentImageEmbed)`
  max-height: 100%;
  height: 100%;
`;
const RemoveButton = styled.div`
  position: absolute;
  top: -8px;
  right: -8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${theme.colors.secondary900};
  color: ${theme.colors.secondary300};

  &:hover {
    cursor: pointer;
    color: ${theme.colors.mainBlue};
  }
`;

const ConversationInputEmbed = ({ uploadedImagedEmbed, onRemove }: IProps) => {
  const { actionsVisible, showActions, hideActions } =
    useActionsVisibilityContext();

  return (
    <ImageWrapper onMouseEnter={showActions} onMouseLeave={hideActions}>
      <StyledImage
        imageUrl={uploadedImagedEmbed.serveUrl}
        onClick={hideActions}
      />
      {actionsVisible && (
        <RemoveButton onClick={onRemove}>
          <SvgIcon
            name="icon-x"
            width={16}
            height={16}
            customFill="currentColor"
          />
        </RemoveButton>
      )}
    </ImageWrapper>
  );
};

export default withActionsVisibilityContext(ConversationInputEmbed);
